module.exports = __webpack_public_path__ + "img/Financial_Advisor_880x660_DemoScreen_Avada-400x300.d9267b1c.jpg";